





























































































import Vue from 'vue';
import Notification from '@/components/modules/App/Profile/Notifications/Notification.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';
import UiDropdown from '@/components/ui/UiDropdown.vue';
import { mainSiteLink } from '@/utils/plugins/links';
import { storeModuleName } from '@/store/modules/ui';
import { isMobile } from 'mobile-device-detect';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { AmoNotification } from '@/requests/mainApi/models/AmoNotification';

interface Data {
  showUnreadNotificationsModal: boolean;
}

interface Methods {
  setConsultationModalStatus: (value: boolean) => void;
  setShowUnreadNotificationsModal: (value: boolean) => void;
  onClickOutsideDropdown: (e: MouseEvent) => void;
  signOut: () => void;
}

interface Computed {
  refMyData: any;
  notificationsModal: any;
  unreadNotifications: AmoNotification[];
}

interface Props {}

export default Vue.extend({
  name: 'SiteHeader',
  components: {
    UiDropdown,
    Notification,
  },
  mixins: [iconsMixin],
  data() {
    return {
      aboutCompanyOptions: [
        {
          href: `${mainSiteLink}/about/`,
          label: this.$t('menu.topNav.companyName'),
        },
        {
          href: `${mainSiteLink}/abd/`,
          label: this.$t('menu.topNav.groupOfCompanies'),
        },
        {
          href: `${mainSiteLink}/faq/`,
          label: this.$t('menu.topNav.FAQ'),
        },
        {
          href: `${mainSiteLink}/docs/`,
          label: this.$t('menu.topNav.documents'),
        },
      ],
      purchaseOptions: [
        {
          href: `${mainSiteLink}sdelka/`,
          label: this.$t('menu.topNav.ownershipDetails'),
        },
        {
          href: `${mainSiteLink}mortgage/`,
          label: this.$t('menu.topNav.mortgage'),
        },
        {
          href: `${mainSiteLink}trade-in/`,
          label: this.$t('menu.topNav.tradeIn'),
        },
        {
          href: `${mainSiteLink}sposoby-pokupki/rassrochka/`,
          label: this.$t('menu.topNav.installment'),
        },
        {
          href: `${mainSiteLink}sposoby-pokupki/pod-materinskij-kapital/`,
          label: this.$t('menu.topNav.maternityCapital'),
        },
        {
          href: `${mainSiteLink}sposoby-pokupki/certificates/`,
          label: this.$t('menu.topNav.certificatesAndGrants'),
        },
      ],
      isMobile,
      showUnreadNotificationsModal: false,
    };
  },
  computed: {
    ...mapGetters(['favouriteFlats', 'unreadNotifications']),
    refMyData() {
      return this.$refs.myData as any;
    },
    notificationsModal() {
      return this.$refs.notificationsModal as any;
    },
    linkInMenuMyData() {
      if (this.$route.name === 'profileEdit') {
        return {
          link: '/profile',
          text: this.$t('menu.myProfile.goMain'),
        };
      }
      return {
        link: '/profile/edit',
        text: this.$t('menu.myProfile.completeProfile'),
      };
    },
    linkInMenuPersonalPage() {
      if (this.$route.name === 'personalPage') {
        return {
          link: '/profile',
          text: this.$t('menu.myProfile.goMain'),
        };
      }
      return {
        link: '/personal-page',
        text: this.$t('menu.myProfile.goToPersonalPage'),
      };
    },
  },
  mounted() {
    document.addEventListener('click', this.onClickOutsideDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutsideDropdown);
  },
  methods: {
    goAnchor() {
      const anchor = this.$router.currentRoute.hash;
      if (anchor && document.querySelector(anchor)) {
        location.href = anchor;
      }
    },
    getFullLink(route: string) {
      return mainSiteLink + route;
    },
    onExit() {
      this.$analytics.logEvent('exit_profile', {
        screen: 'profile',
      });
      this.signOut();
      this.$router.push('/sign-in');
    },
    onConsultation() {
      this.setConsultationModalStatus(true);
    },
    onBlur() {
      this.refMyData.focus();
      this.refMyData.blur();
      this.$emit('closeMenu');
    },
    onClickOutsideDropdown(e) {
      if (
        (e.target as Element).closest('.header-down__unread') ||
        (e.target as HTMLImageElement).src?.includes('/cross.png')
      ) {
        return;
      }

      if (!(e.target as Element).closest('.notifications-modal')) {
        this.setShowUnreadNotificationsModal(false);
      }
    },
    setShowUnreadNotificationsModal(state) {
      this.showUnreadNotificationsModal = state;
    },
    ...mapActions(['signOut', 'getNotifications']),
    ...mapMutations(storeModuleName, ['setConsultationModalStatus']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
